import { render, staticRenderFns } from "./live-request-minimalistic-card.vue?vue&type=template&id=06fedbfd&scoped=true&"
import script from "./live-request-minimalistic-card.vue?vue&type=script&lang=js&"
export * from "./live-request-minimalistic-card.vue?vue&type=script&lang=js&"
import style0 from "./live-request-minimalistic-card.vue?vue&type=style&index=0&id=06fedbfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fedbfd",
  null
  
)

export default component.exports